import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.less';
import '@/assets/iconfont/iconfont.css'
import '@/assets/css/common.css'
import '@/assets/css/custom-antd.css'

createApp(App).use(store).use(router).use(Antd).use(i18n).mount('#app')
